/**
 * Componente de Loading do Sistema MEDICARE
 * Spinner de carregamento para transições
 */

import React from 'react';
import {
  Flex,
  Spinner,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Carregando...',
  size = 'xl',
  fullScreen = true,
}) => {
  const bgColor = useColorModeValue('white', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.300');

  const content = (
    <VStack spacing={4}>
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor={useColorModeValue('gray.200', 'gray.600')}
        color="medicare.500"
        size={size}
      />
      <Text color={textColor} fontSize="md" fontWeight="medium">
        {message}
      </Text>
    </VStack>
  );

  if (fullScreen) {
    return (
      <Flex
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg={bgColor}
        align="center"
        justify="center"
        zIndex="overlay"
      >
        {content}
      </Flex>
    );
  }

  return (
    <Flex
      align="center"
      justify="center"
      p={8}
    >
      {content}
    </Flex>
  );
};

export default LoadingSpinner;